/**
 * Optional permission that lets restricted roles (STD_EMPLOYEE / HOD, etc.)
 * see the top Overview Dashboard at /dashboard.
 *
 * Unrestricted roles always see /dashboard without this permission.
 */
export const TOP_DASHBOARD_PERMISSION = 'SYSTEM:DASHBOARD:READ';
export const TOP_DASHBOARD_NAV_NAME = 'Dashboard';
